import { Validator } from '@vista-digital/validator';
import { nonEmptyStringValidator } from '../string';
import { seatValidator } from './seat';
export const rowValidator = Validator.object({
    number: Validator.number({ min: 1 }),
    label: nonEmptyStringValidator,
    seats: Validator.array({ items: seatValidator })
});
